<template>
  <div class="wrap">
    <div class="wrapContent">

      <div class="info">
        <!-- 交易状态 -->
        <div class="state">
          <p class="success">
            <span>
              <i class="iconfont icon-shiliangzhinengduixiang"></i>
            </span>
            {{pc_lang.Successful_transaction}}
          </p>
        </div>
        <!-- 交易内容 -->
        <div class="content">
          <div class="formContent">

            <div class="table_1">
              <table>
                <caption>{{accountInfo.trade_notes}}</caption>
                <tbody>
                  <tr>
                    <td>交易流水号:</td>
                    <td>{{accountInfo.trade_serial_no}}</td>
                    <td>仓建时间:</td>
                    <td>{{accountInfo.time}}</td>
                    <td>金额({{accountInfo.currency_short}}):</td>
                    <td class="money">{{accountInfo.amount}}</td>
                  </tr>
                  <tr>
                    <td>交易币种：</td>
                    <td>{{accountInfo.currency_short}}</td>
                    <td>交易类型：</td>
                    <td colspan="3">{{getStatusWords(accountInfo.type)}}</td>
                  </tr>
                  <tr>
                    <td>支付方式：</td>
                    <td>余额</td>
                    <td>交易状态：</td>
                    <td colspan="3">成功</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table_2">
              <table>
                <tbody>
                  <tr class="head">
                    <td>交易号</td>
                    <td>商家描述</td>
                    <td>商家名称</td>
                    <td>商户订单号</td>
                    <td>金额({{accountInfo.currency_short}})</td>
                  </tr>
                  <tr v-for="item in tradeList" :key="item.trade_id">
                    <td class="trade_serial_no">
                      <router-link :to="`/tradeDetails?trade_serial_no=${item.trade_serial_no}`" v-text="item.trade_serial_no || '-'" />
                    </td>
                    <td>{{item.trade_notes || '-'}}</td>
                    <td>{{item.shop_name || '-'}}</td>
                    <td>{{item.mch_order_no || '-'}}</td>
                    <td>{{item.actual_amount || '-'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>

      <!-- FAQ -->
      <div class="FAQ" v-if="FAQ.trade">
        <h5>FAQ</h5>
        <template v-for="(item, i) in FAQ.trade">
          <div>{{item.title}}</div>
          <p>{{item.content}}</p>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import * as API_PAY from '@/api/pay'
import { mapGetters } from 'vuex'
import both from '@/utils/storage'

export default {
  name: 'BalanceDetails',
  components: {

  },
  data() {
    return {
      id: '',
      accountInfo: '',
      tradeList: ''
    }
  },
  computed: {
    ...mapGetters(['FAQ'])
  },
  async mounted() {

  },
  created() {
    this.id = this.$route.query.id
    this.getDealDetails()
  },
  methods: {
    /* 获取详情 */
    getDealDetails() {
      let param = {
        id: this.id
      }
      API_PAY.balanceInfo(param).then(res=> {
        res.data.accountInfo.time = both.getChinaTime(res.data.accountInfo.time * 1000)
        this.accountInfo = res.data.accountInfo
        this.tradeList = res.data.tradeList
      },rej=> {

      })
    },
    /* 对应状态的文字 */
    getStatusWords(type) {
      let words = this.dealType.filter(obj=> {
        return obj.id == type
      })[0]
      return !!words ? words.words : '-'
    }
  }
}
</script>
<style lang="scss" scoped>

.wrapContent{
  background: #fff;
  margin: 20px auto 40px;
  padding: 20px 40px;
  .info{
    .state{
      p{
        padding: 35px 0 15px;
        font-size: 24px;
        &.success{
          color: $blue;
          span{
            background: $blue;
          }
        }
        &.fail{
          color: $red_xi;
          span{
            background: $red_xi;
          }
        }
      }
      span{
        display: inline-flex;
        width: 34px;
        height: 34px;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        i{
          font-size: 24px;
          height: 24px;
          color: #fff;
          display: inline-block;
        }
      }
    }
    .content{
      margin: 0 auto;
      .formContent{
        >div{
          padding: 10px 0;
        }
        .table_1{
          border-bottom: $border;
        }
        table{
          caption{
            text-align: left;
            padding: 5px 10px;
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
          }
          tr{
            &:nth-child(1){
              td{
                // color: #555;
                // font-weight: 600;
              }
            }
          }
          td{
            padding: 8px 10px;
            color: #999;
            &.money{
              color: #ff7b0e !important;
            }
            &:nth-child(odd){
              word-break: break-all;
              width: 110px;
              min-width: 110px;
              color: #555;
              font-weight: 600;
            }
            &:nth-child(even){
              width: 236px;
            }
            &:last-child{
              width: auto;
            }
          }
        }
        .table_2{
          tr{
            &.head{
              td{
                color: #555;
                font-weight: 600;
              }
            }
            td{
              width: 200px;
              color: #999;
              >a{
                &:hover{
                  color: $blue;
                }
              }
              &:last-child{
                width: auto;
              }
              &.trade_serial_no{
                word-break: keep-all;
              }
            }
          }
        }
      }
    }
  }
}
</style>
